import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NextStepsWidget } from '../../models/loyalty-dashboard.model';

const PLACEHOLDER: NextStepsWidget = {
  steps: [
    {
      title: 'Win back 340 lapsed customers',
      body: "They haven't visited in 60+ days. Taquerias that sent a return offer saw about 1 in 5 come back.",
      ctaLabel: 'Create offer',
      emphasis: 'primary',
    },
    {
      title: 'Sign up more card customers',
      body: 'Your sign-up rate trails similar taquerias. A counter card or staff prompt usually closes the gap.',
      ctaLabel: 'Get sign-up kit',
      emphasis: 'secondary',
    },
    {
      title: 'Tuesdays are your slowest day',
      body: 'A members-only Tuesday deal could lift traffic when you have capacity to spare.',
      ctaLabel: 'Plan a deal',
      emphasis: 'secondary',
    },
  ],
};

@Component({
  selector: 'app-next-steps-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="next-steps" *ngIf="data ?? placeholder as w">
      <h2 class="next-steps__title">Suggested next steps</h2>

      <div class="next-steps__grid">
        <div class="step" *ngFor="let step of w.steps">
          <h3 class="step__title">{{ step.title }}</h3>
          <p class="step__body">{{ step.body }}</p>
          <button type="button" class="step__cta" [class.step__cta--primary]="step.emphasis === 'primary'">
            {{ step.ctaLabel }}
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrl: './next-steps-widget.component.scss',
})
export class NextStepsWidgetComponent {
  @Input() data: NextStepsWidget | null = null;

  protected readonly placeholder = PLACEHOLDER;
}
